import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

import {
  getRedirectResult,
  signInWithPopup,
  signInWithRedirect,
} from "firebase/auth";
import { auth, provider, appleProvider } from "../../firebase";

import {
 
  MobileInput,
} from "../../components";
import { loginValidationMobile } from "../../validation/signup";

import { login } from "../../redux/slices/auth/loginSlice";

import Logo from "../../assets/images/logo.png";
import LoginMask from "../../assets/images/Group jackpot.png";
import { loginGoogle } from "../../redux/slices/auth/loginGoogleSlice";
import { setCookies } from "../../helper/utils";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.config.data);
  const [error, setError] = useState({});
  const { t } = useTranslation();

  const [form, setForm] = useState({
    contact: "",
    
   
  });

  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [message, setMessage] = useState("");

  // if (window.top !== window.self) {
  //   console.log("This page is in an iframe. ooo");
  //   console.log("ooo Parent URL:", document.referrer);
  // } else {
  //   console.log("ooo This page is not in an iframe.");
  // }
  const setupRecaptcha = () => {
    // window.recaptchaVerifier = new RecaptchaVerifier(
    //   "recaptcha-container",
    //   {
    //     // size: "invisible",
    //     callback: (response) => {
    //       // reCAPTCHA solved
    //       console.log("Recaptcha resolved", response);
    //     },
    //   },
    //   auth
    // );

    window.RecaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container", // 1st argument: container ID (or DOM node)
      {
        size: "invisible",
        callback: (response) => {
          console.log("Recaptcha solved:", response, confirmationResult);
        },
        "expired-callback": () => {
          console.log("Recaptcha expired");
        },
      }
      // 3rd argument: auth instance
    );
  };

  const sendOtp = async () => {
    setupRecaptcha();
    console.log(90, phoneNumber, form);
    if (!form.contact) {
      setMessage("Please enter a valid phone number.");
      return;
    }

    const appVerifier = window.RecaptchaVerifier;

    try {
      const confirmation = await signInWithPhoneNumber(
        auth,
        `+${form.contact}`,
        appVerifier
      );

      setConfirmationResult(confirmation);
      window.confirmationResult = confirmation;
      setMessage("OTP sent successfully!");
      navigate("/email-verification", { state: { phoneNumber: form.contact } });
    } catch (error) {
      console.error(error);
      setMessage("Error sending OTP: " + error.message);
    }
  };

  const verifyOtp = async () => {
    if (!otp || !confirmationResult) {
      setMessage("Please enter OTP.");
      return;
    }
    try {
      const result = await confirmationResult.confirm(otp);
      // User signed in successfully.
      const user = result.user;
      console.log("User signed in:", result);
      setMessage("Phone number verified!");
    } catch (error) {
      console.error(error);
      setMessage("Invalid OTP.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // navigate("/email-verification", { state: { id: "" } });
    const { errors, isValid } = loginValidationMobile(form);

    
    if (!isValid) {
      setError(errors);
    } else {
     
      dispatch(login(form))
        .unwrap()
        .then((res) => {
          console.log(res);
          if (res.success) {
            navigate("/email-verification", { state: { id: res.user._id } });
          } else {
            toast.error("User not found");
          }
        })
        .catch((error) => {
          toast.error(error.message);
          console.error("Failed :", error);
        });

      // dispatch(checkUser(form))
      //   .unwrap()
      //   .then((res) => {
      //     console.log(res);
      //     if (res.success) {
      //       sendOtp()

      //     } else {
      //       toast.error("User not found")
      //     }
      //   })
      //   .catch((error) => {
      //     // toast.error(error.message);
      //     console.error("Failed :", error);
      //   });
    }
  };

  const handleChange = (e) => {
    // e.preventDefault();
    const { name, value } = e;
    console.log(117, name, value);

    setForm((prev) => ({ ...prev, [`${name}`]: value }));
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };
  const handleChangeText = (e) => {
    // e.preventDefault();
    const { name, value } = e.target;
    console.log(117, name, value);

    setForm((prev) => ({ ...prev, [`${name}`]: value }));
    setError((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log("User Info:", form, configData);
      const idToken = await user.getIdToken();
      const payload = {
        idToken: idToken,
        // agentCode: "",
        agentCode:
          form.agentCode
            ? form.agentCode
            : configData?.agentCode || "",
        referralCode: form.referralCode,
      };
      
      if (configData) {
        dispatch(loginGoogle(payload))
          .unwrap()
          .then((res) => {
            console.log(res);
            if (res.success) {
              toast.success(res.message);
              setCookies("xcasino_token", res.token);
              navigate("/");
            }
          })
          .catch((error) => {
            toast.error(error.message);
            console.error("Failed :", error);
          });

        console.log("ID Token:", idToken);
      } else {
        toast.error("couldn't find Agent code.");
      }
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    }
  };
  // const handleAppleLogin = async () => {
  //   try {
  //     appleProvider.addScope("email");
  //     appleProvider.addScope("name");

  //     const result = await signInWithRedirect(auth, appleProvider);
  //     const user = result.user;
  //     console.log("User Info:", result);
  //     const idToken = await user.getIdToken();
  //     console.log("Apple ID Token:", idToken);
  //   } catch (error) {
  //     console.error("Apple Sign-In Error:", error);
  //   }

  //   // Optional: Customize scopes if needed
  // };

  const handleAppleLogin = async () => {
    try {
      await signInWithRedirect(auth, appleProvider);
    } catch (error) {
      console.error("Apple Sign-In Error:", error);
    }
  };

  useEffect(() => {
    const fetchRedirectResult = async () => {
      try {
        const result = await getRedirectResult(auth);
        if (result) {
          const user = result.user;
          console.log("Apple User Info:", user);

          const idToken = await user.getIdToken();
          console.log("Apple ID Token:", idToken);
        }
      } catch (error) {
        console.error("Apple Redirect Error:", error);
      }
    };

    fetchRedirectResult();
  }, []);

  return (
    <div className="p-2 bg-image p-md-4 mt-4 mt-md-3 vh-100">
      {/* min-vh-100 */}

      {/* <div style={{ maxWidth: "400px", margin: "50px" }}> */}
      {/* <h2>Phone Number Verification</h2>
        <input
          type="text"
          placeholder="+1XXXXXXXXXX"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          style={{ width: "100%", padding: "8px", marginBottom: "8px" }}
        />
        <button onClick={sendOtp} style={{ width: "100%", padding: "8px" }}>
          Send OTP
        </button> */}

      {/* {confirmationResult && (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={{ width: "100%", padding: "8px", marginTop: "8px" }}
            />
            <button
              onClick={verifyOtp}
              style={{ width: "100%", padding: "8px", marginTop: "8px" }}
            >
              Verify OTP
            </button>
          </>
        )} */}

      <div id="recaptcha-container"></div>
      {/* <p className="text-white">{message}</p> */}
      {/* </div> */}

      <div
        className={`row p-2 mx-2 mx-xs-2 mx-sm-2 mx-md-2 mx-lg-0 mx-xl-0 signup-height 
           border-radius-40 bg-dark bg-dark-border`}
        style={{ borderRadius: "60px" }}
        //  minHeight: "92vh",
      >
        <div
          className={`col-12 col-md-6 order-2 order-md-1 
           shadow bg-white p-4 m-0 align-content-center signup-height
          border-radius-40 bg-purple-dark h-md-auto auth-image-section`}
          style={{ borderRadius: "50px" }}
        >
          <img
            src={LoginMask}
            alt=""
            className="w-70 d-flex m-auto auth-image"
          />
        </div>
        <div className="col order-1 order-md-2 flex-grow-1 p-3 p-md-4 p-lg-4 text-center">
          <div className=" mx-auto mx-md-auto mx-lg-auto col-12 col-md-10 col-lg-8 col-xl-8">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="mb-2 mb-md-2 mb-md-lg-2 mb-xl-5"
              style={{ maxHeight: "50px", width: "auto" }}
            />
            <h2 className="mb-2 hero-heading">{t("welcome", { name: "" })}</h2>
            <p className="text-white mb-2 mb-md-2 mb-lg-2 mb-xl-4">
              {t("subTitle")}
            </p>

            <form onSubmit={handleSubmit}>
              <MobileInput
                name={"contact"}
                title={t("SignUpPage.phoneNumber")}
                type={"contact"}
                value={form.contact}
                error={error.contact}
                handleChange={handleChange}
                placeholder={t("Placeholder.phone")}
                page={"login"}
              />

              <div className="mt-3">
                <div className="my-2 mb-2 mb-md-4 mb-lg-4 ">
                  <button
                    type="submit"
                    className="btn-purple btn-purple-shadow btn col-12 py-2 fw-semibold"
                    onClick={(e) => {
                      // e.preventDefault();
                      handleSubmit(e);
                    }}
                  >
                    <span className=" text-white-btn text-uppercase">
                      {t("signIn")}
                    </span>
                  </button>
                </div>

                <span className="text-white fs-12">
                  {t("loginWith")}{" "}
                  <span
                    className="cursor-pointer text-purple fw-semibold"
                    onClick={() => {
                      navigate("/signin-username");
                    }}
                  >
                    {t("username")}
                  </span>
                </span>
                <br />

            
                
                {/* <span className="text-white fs-14">{t("or")}</span>
                <div className="my-2 my-md-2 my-lg-2 my-xl-3 ">
                  <TextInput
                    name={"referralCode"}
                    title={t("SignUpPage.referralCode")}
                    type={"text"}
                    value={form.referralCode}
                    
                    handleChange={handleChangeText}
                    placeholder={t("Placeholder.referralCode")}
                    // page={"signup"}
                  />

                  <TextInput
                    name={"agentCode"}
                    title={t("SignUpPage.agentCode")}
                    type={"text"}
                    value={form.agentCode}
                    // error={error.agentCode}
                    handleChange={handleChangeText}
                    placeholder={t("Placeholder.agent")}
                    page={"signup"}
                  />

                  <div
                    className="p-2 social-logo rounded-2 my-2 my-md-2 my-lg-2 my-xl-3 cursor-pointer d-flex align-items-center"
                    onClick={handleLogin}
                  >
                    <div className="flex-shrink-0 me-2">
                      <img src={Google} alt="Google" className="google-icon" />
                    </div>
                    <div className="flex-grow-1 text-center w-100">
                      <span className="text-white">Sign In with Google</span>
                    </div>
                  </div>

                 
                </div> */}

                {/* <span className=" ps-2 fs-12 form-label">
                  {t("dontHaveAcc")}{" "}
                  <span
                    className="cursor-pointer text-purple fw-semibold"
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >
                    {t("signUp")}{" "}
                  </span>
                </span> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
